// extracted by mini-css-extract-plugin
export var carrierIconPlaceholder = "_9y-1";
export var dragButton = "_9y-5";
export var sortableCell = "_9y-4";
export var sortableNameCell = "_9y-3";
export var sortableRow = "_9y-0";
export var tableHeader = "_9y-6";
export var tableHeaderWithCardHeader = "_9y-7";
export var weightInputRow = "_9y-2";